module.exports = __webpack_public_path__ + "img/8.55839ec0.png";